import React from 'react';

import cn from 'classnames';

import { AdminConversationCreateCategory } from '@features/AdminConversationCreateCategory';
import { Flex, UiText } from '@shared/ui';

import cls from './AdminConversationHeader.module.css';
import { useAdminConversationHeader } from '../lib/hooks/useAdminConversationHeader';

interface AdminConversationHeaderProps {
    classes?: string;
}

export const AdminConversationHeader = ({ classes }: AdminConversationHeaderProps) => {
    const { t } = useAdminConversationHeader();

    return (
        <Flex
            align="center"
            justify="between"
            className={cn(cls.AdminConversationHeader, [classes])}
        >
            <UiText variant="heading">
                {t('AdminConversationHeader.AdminConversationHeader.UiText')}
            </UiText>
            <AdminConversationCreateCategory />
        </Flex>
    );
};
